<template>
  <div>
    <div v-lazy:background-image="'/static/img/teaser-bg.png'" class="hero bg-dark">
      <div class="hero-inner">
        <div class="container">
          <div class="hero-body">
            <h1 class="text-center" v-html="content.h1Text"></h1>
            <p class="lead text-center mb-5" v-html="content.leadText"></p>

            <div class="row align-items-center">
              <div class="col-xs-12 col-md d-flex justify-content-center align-items-center flex-column mb-5 mb-lg-0">
                <a @click="clickedVideo = true; $store.dispatch('playVideo')"
                  v-if="clickedVideo == false"
                  href="javascript:" 
                  v-lazy:background-image="'/static/img/video-thumbnail.png'"
                  class="video-thumbnail w-0"></a>
                  
                  <iframe v-if="clickedVideo" class="video" type="text/html" 
                    width="500" 
                    height="305"
                    src="https://www.youtube.com/embed/yqGJQcNeoho?autoplay=1&amp;rel=0&amp;showinfo=0"
                    allow="encrypted-media" 
                    frameborder="0" 
                    allowfullscreen></iframe>
              </div>
              <div class="col d-flex justify-content-center">
                <div class="d-block">
                  <div class="buybox">
                    <h2 class="headline mb-4">Verbrauch berechnen</h2>                    
                    <alfa-calculator></alfa-calculator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-dark">
      <div class="container py-5">
        <div class="row d-flex align-items-center text-center text-sm-left">
          <div class="col-xs-12 col-sm-6 col-md-4 mb-4 mb-sm-0">
            <blockquote class="blockquote">
              <div class="mb-2">
                <div style="height: 27px">
                  <img v-lazy="'/static/img/5stars.png'" alt="5 Sterne">
                </div>
              </div>
              <p class="mb-1">Bin vollauf begeistert von Alfa EASY Flachdachabdichtung! Sehr gute und schnelle Verarbeitung! Und schnell belastbar! Danke!</p>
              <footer class="blockquote-footer">Meinung von Uwe M.</footer>
            </blockquote>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 mb-5 mb-sm-0">
            <blockquote class="blockquote">
              <div class="mb-2">
                <div style="height: 27px">
                  <img v-lazy="'/static/img/5stars.png'" alt="5 Sterne">
                </div>
              </div>
              <p class="mb-1">Leicht zu verarbeiten, gute Haftung und qualitativ hochwertig. Zudem praktische Verpackung und gutes Preis-Leistungsverhältnis!</p>
              <footer class="blockquote-footer">Meinung von Andreas</footer>
            </blockquote>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 mt-sm-5 mt-md-0 text-center text-md-left">
            <div class="mb-3">
              <div style="height: 139px">
                <img style="border: solid 2px #fff; border-radius: 3px;" v-lazy="'/static/img/heimwerker-praxis.png'" alt="">              
              </div>
            </div>
            <div>
              <p class="m-0 text-white">Beim Praxistest von "Heimwerker Praxis" erreichte unsere EASY Flachdachabdichtung die Spitzen-Note von 1,5.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-5 bg-secondary">
      <div class="container py-5">
        <div class="row d-flex align-items-center">
          <div class="col-xs-12 col-lg-3 mb-4 mb-lg-0 text-center">
            <div style="height: 156.25px">
              <img class="img-fluid" v-lazy="'/static/img/product.png'" style="max-width: 250px" alt="Alfa EASY Flachdachabdichtung 1K">    
            </div>
          </div>
          <div class="ml-lg-2 col">
            <div class="benefits row">
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> Einfache Verarbeitung in 2 Anstrichen
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> Kurze Aushärtungszeit, sofort wasserdicht
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> 5 Jahre Gewährleistung
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> Rissüberbrückend bis 3 mm
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> UV- und wetterbeständig, überstreichbar
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="benefit">
                  <i class="fa fa-check"></i> Gebrauchsfertig und lösemittelfrei
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container tutorial">
      <div class="row">
        <div class="col">
          <h2 class="mb-3 mb-sm-5">Schnell und einfach {{ content.objectText }} abdichten</h2>
        </div>
      </div>
      <div class="row mb-3 mb-sm-4">
        <div class="col-sm-4 order-2 order-sm-1">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdach-untergrund-vorbereiten.jpg'" 
              alt="Flachdach mit dem Besen abkehren">
          </div>
        </div>
        <div class="col d-flex justify-content-center flex-column order-1 order-sm-2 mb-3 mb-sm-0">
          <h3>Untergrund vorbereiten</h3>
          <p>Um eine optimale Haftung zu erzielen, muss der Untergrund fest, tragfähig und frei von Verunreinigungen sein. Die zu beschichtende Fläche darf keine Reste von Öl, Fett, Staub und anderen Trennschichten aufweisen. Lose liegende Teile wie Steine und Reste von Altbelägen sind komplett zu entfernen.</p>

          <p class="mb-0">Fugen sind mit Flachdachreparatur 1K zu befüllen. Die Ränder und Überlappungen werden mit UV-Gewebeband abgeklebt, um einen sauberen Übergang der Randbereiche zu gewährleisten.</p>
        </div>
      </div>
      <div class="row mb-4 mb-sm-5">
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdach-abkleben-gewebeband.jpg'" 
              alt="Flachdach mit Gewebeband abkleben">
          </div>
        </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdach-abkleben-gewebeband-ecken.jpg'" 
              alt="Auch die Ecken müssen abgeklebt werden">
          </div>
        </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
            v-lazy="'/static/img/flachdachabdichtung-kurz-umruehren.jpg'" 
            alt="Den Inhalt des Beutels kurz umrühren">
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <h3>Erste Schicht auftragen</h3>
          <p>EASY Flachdachabdichtung 1K wird direkt aus dem 7 kg Beutel verarbeitet. Inhalt kurz anrühren, auf die Fläche leeren und den Dichtstoff mit einem Roller oder Bürste bzw. einem breiten Pinsel in einer Stärke von 1 mm auftragen.</p>
          <p>Die erste Schicht muss ca. 3 Stunden bei 23°C und 50% relativer Luftfeuchtigkeit trocknen. In besonders rissgefährdeten oder beanspruchten Bereichen und Problemzonen empfehlen wir, proteXos Fleece in die noch feuchte Schicht mit einzuarbeiten.</p>
        </div>
        <div class="col-sm-4">
          <img class="img-fluid rounded" 
            v-lazy="'/static/img/material-verteilen-randbereiche.jpg'" 
            alt="Das Material an den Randbereichen auftragen">
        </div>
      </div>
      <div class="row mb-3 mb-sm-5">
        <div class="col-sm-4 order-3 order-sm-1 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdachabdichtung-verteilen.jpg'" 
              alt="Flachdachabdichtung verteilen">
          </div>
        </div>
        <div class="col-sm-4 order-2 order-sm-2 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdachabdichtung-verteilen-erste-schicht.jpg'" 
              alt="Flachdachabdichtung verteilen">
          </div>
        </div>
        <div class="col-sm-4 order-1 order-sm-3 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/material-verteilen-walze.jpg'" 
              alt="Eine Walze verwenden">
          </div>
        </div>
      </div>
      <div class="row mb-3 mb-sm-4">
        <div class="col-sm-4 order-2 order-sm-1">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdachabdichtung-zweite-schicht-rand.jpg'" 
              alt="Zweite Schicht der Flachdachabdichtung am Randbereich verteilen">
          </div>
        </div>
        <div class="col d-flex justify-content-center flex-column order-1 order-sm-2 mb-3 mb-sm-0">
          <h3>Zweite Schicht auftragen</h3>
          <p>EASY Flachdachabdichtung 1K wird direkt aus dem 7 kg Beutel verarbeitet. Inhalt kurz anrühren, auf die Fläche leeren und den Dichtstoff mit einem Roller oder Bürste bzw. einem breiten Pinsel in einer Stärke von 1 mm auftragen.</p>
          <p class="mb-0">Der Flüssigkunststoff ist nach 12 Stunden bei 23°C und 50% relativer Luftfeuchtigkeit komplett ausgetrocknet. Das Material ist begehbar und es können nachfolgende Tätigkeiten aufgenommen werden. Temperaturschwankungen oder Änderungen der Luftfeuchtigkeit können zu Verzögerung der Aushärtung führen.</p>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdachabdichtung-zweite-schicht.jpg'" 
              alt="Zweite Schicht auftragen">
            </div>
        </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/material-zweite-schicht.jpg'" 
              alt="Zweite Schicht auftragen">
            </div>
        </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="lazy-container">
            <img class="img-fluid rounded" 
              v-lazy="'/static/img/flachdach-abgedichtet.jpg'" 
              alt="Abgedichtetes Flachdach">
            </div>
        </div>
      </div>
    </div>
    <div class="bg-dark py-5">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-5 m-auto">
            <div class="card">
              <div class="card-body" style="padding: 35px">
                <h3 class="font-weight-bold mb-4">Verbrauch berechnen</h3>
                <alfa-calculator></alfa-calculator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      keyword: '',
      videoIsVisible: false,
      clickedVideo: false,
      isB2B: false,
      flachdachSet: false
    }
  },
  computed: {
    ...mapGetters([
      'visitCount',
      'playedVideo'
    ]),
    content () {
      return this.$store.getters.getContent('flachdach', this.keyword)
    }
  },
  methods: {
    toggleVideo () {
      this.videoIsVisible = !this.videoIsVisible
    }
  },
  mounted () {
    this.keyword = this.$route.query.keyword
    this.$store.dispatch('viewPage')
    this.$store.dispatch('setKeyword', this.keyword)
  }
}
</script>


<style lang="scss">
  @import "~bootstrap/scss/bootstrap";

  img[lazy=loading] {
    opacity: 0 !important;
  }

  img[lazy=loaded] {
    opacity: 1;
    transition: opacity 1s;
  }

  .lazy-container {
    display: block;
    position: relative;
    height: 0;
    padding-bottom: 64%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .hero {
    // background-image: url('/static/img/teaser-bg.png');
    background-size: cover;
    background-position: 50% 50%;
    .hero-body {
      padding: 4em 0;
    }
    h1 {
      font-size: 2.5rem;
      font-weight: 600;
      color: #fff;
      @include media-breakpoint-down(sm) {
        font-size: 1.8rem;
      }
    }
  }
  .lead {
    font-size: 2rem;
    color: gold;
    @include media-breakpoint-down(sm) {
      font-size: 1.4rem;
    }
  }
  .video-thumbnail {
    display: block;
    width: 500px;
    height: 305px;
    box-shadow: 
      0 5px 5px -3px rgba(0,0,0,.2),
      0 8px 10px 1px rgba(0,0,0,.14),
      0 3px 14px 2px rgba(0,0,0,.12);
    // background-image: url('/static/img/video-thumbnail.png');
    background-size: cover;
    background-position: 50% 50%;
    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
  .video {
    background-color: #000;
    box-shadow: 
      0 5px 5px -3px rgba(0,0,0,.2),
      0 8px 10px 1px rgba(0,0,0,.14),
      0 3px 14px 2px rgba(0,0,0,.12);
    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
  .close {
    position: relative;
    right: -15px;
    top: -30px;
    color: #fff;
    cursor: pointer;
  }
  .guide {
    .guide-step {
      border-bottom: solid 1px #ccc;
    }
  }
  .buybox {
    width: 400px;
    padding: 35px 35px;
    background-color: #fff;
    border-radius: $border-radius;
    box-shadow: 
      0 5px 5px -3px rgba(0,0,0,.1),
      0 8px 10px 1px rgba(0,0,0,.10),
      0 3px 14px 2px rgba(0,0,0,.08);
    .headline {
      font-size: 1.5rem;
      font-weight: 700;
    }
    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
  blockquote {
    color: #fff;
    margin-bottom: 0;
    p {
      font-size: 1.2rem;
    }
  }
  .benefits {
    .benefit {
      display: block;
      margin-bottom: 10px;
      padding: 15px 20px;
      border-radius: 100px;
      background-color: #fff;
    }
    .fa {
      margin-right: 10px;
      color: #e4001b;
    }
  }
  .tutorial {
    img {
      opacity: .85;
      box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.2);
      &:hover {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue